import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import debounce from "lodash.debounce";
import * as moment from "moment";
import { Helmet } from "react-helmet";
import PalletsSidebar from "web/components/PalletsSidebar";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import { useDispatch, useSelector } from "react-redux";
import AlertModal from "web/components/AlertModal";
import Layout from "web/components/Layout";
import Spinner from "web/components/Spinner";
import Breadcrumb from "web/components/Breadcrumb";
import DropDown from "web/components/DropDown";
import MyPostedFilter from "web/components/MyPostedFilter";
import ManageReccuring from "web/assets/images/ManageReccuring.png";
import { postLoadListV2, postLoadRecurringListV2, postLoadDelete, recurrencePostLoadList } from "redux/actions/postLoad";
import { loadInventoryBagageUpdate } from "redux/actions/notification";
import SearchIcon from "web/assets/images/search-icon.png";
import FilterIcon from "web/assets/images/filterIcon.png";
import styles from "./myPostLoad.module.scss";
import MyPost from "./MyPost";
import styled from "styled-components";
import BlueBackIcon from "web/assets/svg/BlueBackIcon";
import { fetchLanguageContentNew } from "redux/actions/language";

const MyPostLoad = (props) => {
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const urlObject = useSelector((state) => state.urlParameters.createdNeeds);
  let history = useHistory();
  const dispatch = useDispatch();
  const [response, setResponse] = useState(undefined);
  const [totalPageState, setTotalPageState] = useState("");
  const [toggleCondition, settoggleCondition] = useState(false);
  const [pageType, setPageType] = useState();
  const [activeSearch, setActiveSearch] = useState();
  const [postNameSearch, setPostNameSearch] = useState("");
  const [expanded, expandedState] = useState();
  const [type, setType] = useState();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  const [pageLoader, setPageLoader] = useState(true)

  const token = localStorage.getItem("token");

  let toDate = new Date();
  let fromDate = new Date();
  let todayDate = new Date();
  todayDate.setDate(todayDate.getDate());
  toDate.setDate(toDate.getDate() + 10);
  fromDate.setDate(fromDate.getDate() - 20);
  const [requestedFromDate, setRequestedFromDate] = useState(fromDate.toISOString().substring(0, 10));
  const [requestedToDate, setRequestedToDate] = useState(toDate.toISOString().substring(0, 10));

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const selectedPageObj = useSelector((state) => state.urlParameters.selectedPage);

  let selectedPageNo = 1
  if (selectedPageObj?.selectedPage) selectedPageNo = selectedPageObj?.selectedPage
  const [pageNumberState, setPageNumberState] = useState(selectedPageNo);

  const [pageLanguageContents, setPageLanguageContents] = useState();
  useEffect(() => {
    if (languageContentNew?.PostLoad_Page) setPageLanguageContents(languageContentNew.PostLoad_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const [sortState, setSortState] = useState("DESC");
  const [filterState, setFilterState] = useState("AVAILABLE");
  const [filterPopUpModal, setFilterPopUpModal] = useState(false);
  const [isFiterModalSeleccted, setIsFilterModalSelected] = useState(false)
  const [recurrenceListState, setRecurrenceListState] = useState()

  const [filterValue, setFilterValue] = useState();

  // breadcrumbs related states
  const [breadcrumbMapArr, setBreadcrumbMapArr] = useState([{ name: 'Home', link: "/dashboard", }])
  const [breadcrumbSelectedPage, setBreadcrumbSelectedPage] = useState('My Posted Pallet Needs')


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filterArr = [
    {
      id: "0",
      label: pageLanguageContents?.Header[0]?.All,
      value: "ALL",
    },
    {
      id: "1",
      label: pageLanguageContents?.Header[1]?.ActivePost,
      value: "AVAILABLE",
    },
    {
      id: "2",
      label: pageLanguageContents?.Header[2]?.InactivePost,
      value: "EXPIRED",
    },
  ];

  const dropDownArr = [
    {
      id: "0",
      label: pageLanguageContents?.Header[4]?.OldPost,
      value: "ASC",
    },
    {
      id: "1",
      label: pageLanguageContents?.Header[5]?.LatestPost,
      value: "DESC",
    },
  ];

  useEffect(() => {
    const { location } = props;
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.get("type")) {

      setType(queryParams.get("type"))
      setActiveSearch(queryParams.get("activeSearch"))
      expandedState(queryParams.get("expanded"))
      if (!localStorage.getItem('token')) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setPageType(queryParams.get("postType"));
        fetchMyAPI(pageNumberState, sortState, filterState, postNameSearch, requestedFromDate, requestedToDate);
      }
    } else {
      if (!urlObject) {
        setType('postedNeeds')
        setActiveSearch('Dashboard')
        expandedState('panel1')
        setPageType('PostLoad');
      } else {
        setType(urlObject && urlObject.type)
        setActiveSearch(urlObject && urlObject.activeSearch)
        expandedState(urlObject && urlObject.expanded)
      }

      if (!localStorage.getItem('token')) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        if (urlObject) setPageType(urlObject?.postType);
        fetchMyAPI(pageNumberState, sortState, filterState, postNameSearch, requestedFromDate, requestedToDate);
      }
    }
    let obj = { selectedPage: undefined };
    dispatch({ type: "BIDS_PAGINATION", payload: obj });
  }, []);

  const fetchMyAPI = async (pageNumber, sort, filterBy, postNameSearch, requestedFromDate, requestedToDate, values, typeOfFetch) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      setPageNumberState(pageNumber)
      let response = "";
      setResponse()

      let startDateTemp = moment(requestedFromDate ? requestedFromDate : values?.fromDate)
      let endDateTemp = moment(requestedToDate ? requestedToDate : values?.toDate)

      let data;
      data = {
        authId: localStorage.getItem('authId'),
        locationId: [localStorage.getItem('locationID')],
        rdd: sort === 'DESC' ? true : false,
        size: 10,
        number: (pageNumber - 1) || 0,
        sort: sort,
        postType: "NEED",
        status: [filterBy],
        searchBy: postNameSearch || "",
        // filter modal fields
        startDate: moment(startDateTemp).format('YYYY-MM-DD'),
        endDate: moment(endDateTemp).format('YYYY-MM-DD'),
        filters: { filterStatus: 'ALL' },
        filter: isFiterModalSeleccted
      }
      if (typeOfFetch === 'filterModal' || typeOfFetch === 'searchField' || typeOfFetch === 'filterRefresh') {
        if (values?.city && values?.city !== '') data.filters['city'] = values?.city
        if (values?.state && values?.state !== '' && values?.state !== 'All') data.filters['state'] = values?.state
        if (values?.postName && values?.postName !== '') data.filters['postName'] = values?.postName
        if (values?.status && values?.status !== '') data.filters['filterStatus'] = values?.status
        if (typeOfFetch === 'filterModal') data.filter = true
        if (typeOfFetch === 'searchField' && values?.isFilter) data.filter = true
        if (typeOfFetch === 'filterRefresh') data.filter = false
      } else {
        if (filterValue?.city && filterValue?.city !== '') data.filters['city'] = filterValue?.city
        if (filterValue?.state && filterValue?.state !== '' && filterValue?.state !== 'All') data.filters['state'] = filterValue?.state
        if (filterValue?.postName && filterValue?.postName !== '') data.filters['postName'] = filterValue?.postName
        if (filterValue?.status && filterValue?.status !== '') data.filters['filterStatus'] = filterValue?.status
      }

      response = await dispatch(postLoadListV2(data, token));

      if (response.success) {
        setPageLoader(false)
        //loadBagageUpdateApi();
        if (response?.data?.myPostedNeeds) {
          let tempPostedNeedsData = response?.data?.myPostedNeeds
          if (tempPostedNeedsData?.length > 0) {
            setResponse(tempPostedNeedsData);
            let totalElements = response?.data?.totalElements
            setTotalPageState(totalElements)
            settoggleCondition(false)
          } else {
            setResponse(undefined)
            settoggleCondition(true)
          }
        } else {
          setTotalPageState("");
          settoggleCondition(true)
          setResponse(undefined);
        }
      } else {
        setPageLoader(false)
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else if (response.data?.error?.message === 'No results.') {
          setResponse([])
          setTotalPageState("")
          settoggleCondition(true)
        } else {
          setModalContent(response.data?.error?.message || 'Something went wrong, please try again in sometime.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const fetchManageRecurringAPI = async (pageNumber, postNameSearch, values, typeOfFetch) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let response = "";
      setResponse()
      let data;
      data = {
        authId: localStorage.getItem('authId'),
        locationId: localStorage.getItem('locationID'),
        size: 10,
        pgNumber: (pageNumber - 1) || 0,
        sort: "DESC",
        filters: null
      }

      if (postNameSearch) {
        if (data.filters === null) {
          data.filters = {
            searchBy: postNameSearch,
          }
        } else
          data.filters.searchBy = postNameSearch;
      }
      if (typeOfFetch === 'filterModal' || typeOfFetch === 'searchField') {
        if (values?.city && values?.city !== '') {
          if (data.filters === null) data.filters = {}
          data.filters['city'] = values?.city
        }
        if (values?.state && values?.state !== '') {
          if (data.filters === null) data.filters = {}
          data.filters['state'] = values?.state
        }
        if (values?.postName && values?.postName !== '') {
          if (data.filters === null) data.filters = {}
          data.filters['postName'] = values?.postName
        }
      } else {
        if (filterValue?.city && filterValue?.city !== '') {
          if (data.filters === null) data.filters = {}
          data.filters['city'] = filterValue?.city
        }
        if (filterValue?.state && filterValue?.state !== '') {
          if (data.filters === null) data.filters = {}
          data.filters['state'] = filterValue?.state
        }
        if (filterValue?.postName && filterValue?.postName !== '') {
          if (data.filters === null) data.filters = {}
          data.filters['postName'] = filterValue?.postName
        }
      }

      response = await dispatch(postLoadRecurringListV2(data, token));

      if (response.success) {
        setPageLoader(false)
        if (response?.data?.reccDetails) {
          let tempPostedNeedsData = response?.data?.reccDetails
          if (tempPostedNeedsData?.length > 0) {
            setResponse(tempPostedNeedsData);
            let totalElements = response?.data?.totalElements
            setTotalPageState(totalElements)
            settoggleCondition(false)
          } else {
            setResponse(undefined)
            settoggleCondition(true)
          }
        } else {
          setTotalPageState("");
          settoggleCondition(true)
          setResponse(undefined);
        }
      } else {
        setPageLoader(false)
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else if (response.data?.error?.message === 'No Results found.') {
          setResponse([])
          setTotalPageState("")
          settoggleCondition(true)
        } else {
          setModalContent(response.data?.error?.message || 'Something went wrong, please try again in sometime.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const onChangeHandler = (val) => {
    setRecurrenceListState()
    setPageNumberState(1);
    setSortState(val);
    setPostNameSearch('');
    fetchMyAPI(1, val, filterState, '', requestedFromDate, requestedToDate);
  };
  const onChangeHandlerFilter = (val) => {
    let resetFromDate = fromDate.toISOString().substring(0, 10)
    let resetToDate = toDate.toISOString().substring(0, 10)
    setRequestedFromDate(resetFromDate)
    setRequestedToDate(resetToDate)
    setFilterValue()
    setIsFilterModalSelected(false)
    setRecurrenceListState()
    setPageNumberState(1);
    setFilterState(val);
    setPostNameSearch('');
    fetchMyAPI(1, sortState, val, '', resetFromDate, resetToDate, null, 'filterRefresh');
  };

  const callDeletePostAPi = async (id) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let response = await dispatch(postLoadDelete(id, token));

      if (response?.success) {
        setPageNumberState(pageNumberState);
        setModalContent(response?.data?.msg);
        setModalLink("");
        toggleModal();
        fetchMyAPI(pageNumberState, sortState, filterState, postNameSearch, requestedFromDate, requestedToDate);
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const handleDebounceSearch = useCallback(debounce((data) => {
    if (data.recurrenceListState) {
      fetchManageRecurringAPI(1, data.searchText, data.filterValues, 'searchField')
    } else {
      fetchMyAPI(1, data.sortState, data.filterState, data.searchText, data.requestedFromDate, data.requestedToDate, data.filterValues, 'searchField')
    }
  }, 500), []);

  const currentDataAndPageDetails = () => {
    let currnetPageNumber = pageNumberState
    let startRecord = ((currnetPageNumber - 1) * 10) + 1
    let endRecord = startRecord + 9
    if (endRecord > totalPageState) endRecord = totalPageState
    return (
      totalPageState > 0 && <p style={{ textAlign: 'end' }}>Showing {startRecord} - {endRecord} out of {totalPageState}</p>
    )
  }

  const breadCrumbCallBackFunction = (item) => {
    if (item.link === "/my-posted-pallet-needs" || item === '/my-posted-pallet-needs') {
      setBreadcrumbMapArr([{ name: 'Home', link: "/dashboard" }])
      setBreadcrumbSelectedPage('My Posted Pallet Needs')
      setRecurrenceListState()
      let resetFromDate = fromDate.toISOString().substring(0, 10)
      let resetToDate = toDate.toISOString().substring(0, 10)
      setRequestedFromDate(resetFromDate)
      setRequestedToDate(resetToDate)
      setPageNumberState(1)
      setPostNameSearch('')
      setSortState('DESC')
      setFilterState('AVAILABLE')
      setFilterValue()
      setIsFilterModalSelected(false)
      fetchMyAPI(1, 'DESC', 'AVAILABLE', '', resetFromDate, resetToDate, null, 'filterRefresh');
    } else if (item.link === "/dashboard") {
      history.push(item.link)
    }
  }

  return (
    <>
      <Helmet title="View Posted Pallet Needs: Find Matching Pallet Suppliers | PalletTrader" >
        <meta name="description"
          content="Identify pallet suppliers who match the posted pallet needs. Our platform helps you connect with the right partners to fulfill your pallet requirements efficiently." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/my-posted-pallet-needs" />
      </Helmet>
      <Layout selectedSearch={"MyPostLoad"} topBarViewMobile={"hide"}>
        {(loaderVisible || pageLoader) && <Spinner />}
        <div className={styles.maxWidth}>
          <DropMenuContainer>
            <div className={styles.paginationCount}>
              <Breadcrumb
                breadcrumbArr={breadcrumbMapArr}
                selected={breadcrumbSelectedPage}
                fromPage={'myPostedPalletNeeds'}
                title=""
                callBackToParentPage={(item) => breadCrumbCallBackFunction(item)}
              />
              <div></div>
              {currentDataAndPageDetails()}
            </div>
          </DropMenuContainer>
          <DropMenuContainer>
            <div className={recurrenceListState ? styles.dropDownMyPostRecurrence : styles.dropDownMyPost}>
              {recurrenceListState && <div>
                <div className="backButtonStyles" onClick={() => breadCrumbCallBackFunction('/my-posted-pallet-needs')}>
                  <BlueBackIcon />
                  <p style={{ marginLeft: '9px', color: '#00B3FF' }}>Back</p>
                </div>
              </div>}

              {!recurrenceListState &&
                <>
                  <DropDown
                    name="dropDown"
                    data={dropDownArr}
                    searchDropDown={sortState}
                    placeholder={pageLanguageContents?.Header[3]?.SortBy}
                    onChangeHandler={(event) => {
                      onChangeHandler(event.value);
                    }}
                  />
                  <DropDown
                    name="dropDown"
                    data={filterArr}
                    searchDropDown={filterState}
                    placeholder="Filter"
                    onChangeHandler={(event) => {
                      onChangeHandlerFilter(event.value);
                    }}
                  />
                </>
              }
              <SearchWrapper>
                <input
                  type="text"
                  placeholder="Search by post name, material, pallet type, size, grade"
                  value={postNameSearch}
                  onChange={(e) => {
                    setPageNumberState(1);
                    setPostNameSearch(e.target.value);

                    if (filterValue) filterValue.isFilter = isFiterModalSeleccted
                    let apiDataTemp = {
                      recurrenceListState: recurrenceListState,
                      filterState: filterState,
                      sortState: sortState,
                      searchText: e.target.value,
                      requestedFromDate: requestedFromDate,
                      requestedToDate: requestedToDate,
                      filterValues: filterValue,
                    }
                    handleDebounceSearch(apiDataTemp);
                  }}
                />
                <img src={SearchIcon} alt="SearchIcon" />
              </SearchWrapper>

              <FilterWrapper>
                <img
                  src={FilterIcon}
                  alt=""
                  onClick={() => setFilterPopUpModal(true)}
                />
              </FilterWrapper>

              <div className='d-none d-sm-block' style={{ 'flex': '1' }}></div>

              <IconWrapper onClick={() => {
                setPageNumberState(1)
                setPostNameSearch('')
                setFilterValue()
                setIsFilterModalSelected(false)
                setRecurrenceListState(true)
                fetchManageRecurringAPI(1, '')
                setBreadcrumbMapArr([{ name: 'Home', link: "/dashboard" }, { name: 'My Posted Pallet Needs', link: "/my-posted-pallet-needs" }])
                setBreadcrumbSelectedPage('Manage Recurring')
              }}>
                <img
                  className="ml-2"
                  style={{ cursor: "pointer", height: '30px', 'margin-top': '6px', 'margin-right': '5px' }}
                  src={ManageReccuring}
                  alt="Recurring"
                />
                <p style={{ "white-space": "nowrap" }}>Manage Recurring</p>
              </IconWrapper>

            </div>
          </DropMenuContainer>
        </div>
        {response?.length > 0 ?
          <MyPost
            response={response}
            totalPageState={totalPageState}
            pageType={pageType}
            type={type}
            isRecurrenceList={recurrenceListState ? true : false}
            activePage={'PostLoad'}
            activeSearch={activeSearch}
            expanded={expanded}
            filterState={filterState}
            filterArr={filterArr}
            currentPageNumber={pageNumberState}
            deletePost={(id) => {
              callDeletePostAPi(id);
            }}
            callBackFun={(pageNumber, sort, pageType, status, isRepost) => {
              if (isRepost === "repost") {
                setPageNumberState(pageNumberState);
                setFilterState('AVAILABLE')
                fetchMyAPI(1, sortState, 'AVAILABLE', postNameSearch, requestedFromDate, requestedToDate);
              } else {
                if (status === 'editDeleteRecurrence' || recurrenceListState) {
                  setPageNumberState(pageNumber);
                  fetchManageRecurringAPI(pageNumber, postNameSearch)
                } else {
                  setPageNumberState(pageNumber);
                  fetchMyAPI(pageNumber, sortState, filterState, postNameSearch, requestedFromDate, requestedToDate);
                }
              }
            }}
          /> :
          <div className="custom-wrapper-myPost">
            <div className="pd-right-nav">
              <PalletsSidebar
                postType={type}
                activePage={'PostLoad'}
                expandedPallet={expanded}
                activeSearch={activeSearch}
              />
            </div>
            {toggleCondition && response &&
              <div className="left-content">
                <div className={styles.noRecordFound}>
                  No records found
                </div>
              </div>
            }
          </div>
        }
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title=""
          content={modalContent}
          link={modalLink}
        />
        <MyPostedFilter
          isOpen={filterPopUpModal}
          requestedFromDate={requestedFromDate}
          requestedToDate={requestedToDate}
          filterModalValues={filterValue}
          filterType="NEED"
          isRecurrenceFilter={recurrenceListState ? true : false}
          toggle={() => { setFilterPopUpModal(false) }}
          fromDateCallBack={(date) => {
            setRequestedFromDate(moment(date).format(BIDFORMAT));
          }}
          toDateCallBack={(date) => {
            setRequestedToDate(moment(date).format(BIDFORMAT));
          }}
          callBack={(values) => {
            setPageNumberState(1);
            setFilterPopUpModal(false);
            setFilterValue(values)
            setIsFilterModalSelected(true)
            if (recurrenceListState) {
              fetchManageRecurringAPI(1, postNameSearch, values, 'filterModal')
            } else {
              fetchMyAPI(1, sortState, filterState, postNameSearch, requestedFromDate, requestedToDate, values, 'filterModal');
            }
          }}
        />
      </Layout>
    </>
  );
};

export default MyPostLoad;

const DropMenuContainer = styled.div`
  .custom-select__control {
    border-radius: 23px;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
    border: solid 1px #fff;
    background-color: #fff;
    height: 40px;
  }
  .backButtonStyles {
    display: flex;
    align-items: center;
    width: 96px;
    border: 1px solid #00B3FF;
    border-radius: 30px;
    padding: 0px 18px 0px 18px;
    height: 37px;
    cursor: pointer;
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  overflow: auto;
  max-width: 432px;
  min-width: 200px;
  width: 100%;
  height: 40px;
  input {
    background: #ffffff;
    border-radius: 23px;
    border: solid 1px #87cdf1;
    padding: 4px 35px 4px 15px;
    width: 100%;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #00000087;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #00000087;
    }

    ::placeholder {
      color: #00000087;
    }
  }
  img {
    position: absolute;
    right: 10px;
    top: 9px;
    color: #525e66;
    margin: 4px;
  }
  margin: 4px;
`;

const FilterWrapper = styled.div`
  margin-left: 10px;
  margin-bottom: 5px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
  padding: 5px;
  border-radius: 10px;
  img {
    cursor: pointer;
  }
`;
const IconWrapper = styled.div`
    border-radius: 7px;
    background-color: rgb(255, 255, 255);
    cursor: pointer;
    padding: 6px 35px 6px 15px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    margin-bottom: 10px;
    box-shadow: rgb(0 0 0 / 16%) 0px 2px 10px 0px;
    border-color: rgb(10, 85, 135);
    color: black !important;
    max-width: 250px;
`
